module.exports = __webpack_public_path__ + "img/close.efebf2c1.svg";